<div id="settings-{{moi.instanceId}}" class="settings-{{moi.instanceId}}">
    <ng-container *ngComponentOutlet="moi.adminSettingsComponent; injector: moi.injectSettings;"></ng-container>
</div>